// @noflow
/**
 * Pads a number to two significant digits
 * @param  {number} num
 * @return {string}
 */
export function padNumber(num) {
    if (num >= 0) {
        return (num < 10 ? '0' : '') + num;
    } else {
        return (num > -10 ? '-0' : '-') + Math.abs(num);
    }
}



// WEBPACK FOOTER //
// ./src/core/utils/numbers.js